export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const BASE_AWS_S3_URL = process.env.REACT_APP_BASE_AWS_S3_URL;
export const IS_DEV = process.env.REACT_APP_IS_TEST === "true";
